import { useAuthStore } from '../../store';
import PurchaseOrderTable from './PurchaseOrderTable';
import PurchaseOrderFilterHeader from './PurchaseOrderFilterHeader';

const PurchaseOrderPage = () => {
  const api = '/purchase/orders';
  const moduleName = 'PurchaseOrder';
  const moduleCode = 'PO';
  const { user } = useAuthStore();
  const userModuleAccess = user?.moduleAccess?.find(
    (item) => item.module.code === moduleCode,
  );

  return (
    <>
      <div className={'page-wrapper'}>
        <PurchaseOrderFilterHeader />
        <PurchaseOrderTable
          api={api}
          moduleName={moduleName}
          userModuleAccess={userModuleAccess}
          userRole={user?.role}
        />
      </div>
    </>
  );
};

export default PurchaseOrderPage;
